import { stringify } from 'qs'

import {
  TRANSACTIONS_FILTERS_STORAGE_KEY,
  TransactionsFilterFormFields,
  transactionsFilterFormSchema,
} from '../components/transactions-filters/types'

/**
 * Reads and validates the filters persisted in sessionStorage.
 * Returns `null` if there is nothing valid.
 */
function readPersistedTransactionFilters(): TransactionsFilterFormFields | null {
  const raw = sessionStorage.getItem(TRANSACTIONS_FILTERS_STORAGE_KEY)

  if (!raw) {
    return null
  }

  try {
    const parsed = JSON.parse(raw)

    const validated = transactionsFilterFormSchema.parse(parsed)
    return validated
  } catch {
    return null
  }
}

/**
 * Constructs the query string from the persisted filters.
 * If there are no valid filters → returns an empty string.
 */
export function getTransactionsQueryString(): string {
  const filters = readPersistedTransactionFilters()
  if (!filters) {
    return ''
  }
  return stringify(filters, { encode: true })
}
